export default "/fonts/Acrom-Thin.woff?195aab4c218ef799a1671c46640714ec";